<template>
  <div class="administrativeToken">
    <div class="code">{{ code }}</div>
  </div>
</template>

<script>
import { getBackendToken } from "./api.js";
export default {
  name: "administrativeToken",
  components: {},
  props: {},
  data() {
    return {
      interval: null,
      code: "",
    };
  },
  created() {},
  mounted() {
    this.getBackendToken();
    this.interval = setInterval(this.getBackendToken, 60000);
  },
  methods: {
    getBackendToken() {
      const params = {
        mobileNum: this.$route.query.mobileNum || "",
      };
      this.$axios.post(getBackendToken, params).then((res) => {
        if (res.code == 200) {
          this.code = res.msg;
        }
      });
    },
  },
  beforeDestroy() {
    clearInterval(this.interval);
  },
};
</script>

<style scoped lang="less">
.administrativeToken {
  width: 100%;
  height: 100vh;
  box-sizing: border-box;

  background: #f9f9f9;
  .code {
    width: 100%;
    height: 168px;
    text-align: center;
    line-height: 168px;
    color: blue;
    letter-spacing: 10px;
    font-weight: 700;
    font-size: 48px;
    background: #fff;
    // box-shadow: 0px 4px 16px 0px rgba(225, 225, 225, 0.5);
    border-radius: 16px;
  }
}
</style>
